import { useContext } from 'react'
import { SearchPreviewContext } from './SearchPreviewContext'

export default function useSearchPreview() {
  return useContext(SearchPreviewContext)
}
